module.exports = __webpack_public_path__ + "static/littleWomen0s-d7d0c0a637a722feed901ffa734a0ed3.jpg";